import { render, staticRenderFns } from "./InstallerDetailsPage.vue?vue&type=template&id=48e545e6&scoped=true"
import script from "./InstallerDetailsPage.vue?vue&type=script&lang=js"
export * from "./InstallerDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./InstallerDetailsPage.vue?vue&type=style&index=0&id=48e545e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e545e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VBtn,VIcon,VProgressCircular})
